import { put, select } from "redux-saga/effects";
import { selectGameAPIData } from "../selectors";
import * as actions from "../actions";
import { randomizeArray } from "../../../utils/util";

export function* getSorting(payload, getPictureMatchingData) {
    console.log("get Sorting");
    const { from, unSelectedCategories, screens } = payload;
    let newPictureMatchingState = yield select(selectGameAPIData);
    if (!newPictureMatchingState) {
        newPictureMatchingState = yield* getPictureMatchingData(
            null,
            null,
            null,
            "SORTING",
            from,
            null,
            null
        );
        const categories = []
        newPictureMatchingState.questions_en.map((item) => {
            let cate = item.category;
            if (!categories.includes(cate)) {
                categories.push(cate);
            }
        })
        yield put(actions.setGameData({ apiData: newPictureMatchingState, categoryData: categories }));
    }
    const resultItems = [];

    newPictureMatchingState.questions_en.map((item, idx) => {
        let answerData = [];
        let correctAnswer = {
            id: item.answers[0].id,
            image: item.answers[0].image,
            is_correct: item.answers[0].is_correct,
            answerAudio: item.answers[0].audio
        };

        answerData.push(correctAnswer);
        for (let i = 1; i < screens; i++) {
            answerData.push({
                id: item.answers[i].id + i,
                image: item.answers[i].image,
                is_correct: item.answers[i].is_correct,
                answerAudio: item.answers[i].audio

            });
            if (i === 0) {
                answerData.pop()
            }
        }
        if (!unSelectedCategories?.includes(item.category)) {
            resultItems.push({
                id: item.id,
                answers: randomizeArray(answerData),
                text: item.text,
                correct: item.answers[0].id,
                questionId: item.id,
                imagePath: newPictureMatchingState.image_files_path,
                image: item.image,
                audioPath: newPictureMatchingState.audio_files_path,
                categoryName: item.category,
                audio: item.audio
            })
        }
    });


    const displayData = randomizeArray(resultItems);
    const metaFieldData = {
        activeSlide: 0,
        gameData: displayData,
        droppedAnswer: [],
        questionsAnswered: [],
        activeAnswers: displayData[0].answers,
        correctAnswerCount: 0,
    };
    return { displayData, metaFieldData };
}
